module.exports = __webpack_public_path__ + "static/c12-e43384f2feaec23663b82afef5d294f0.jpg";